<div class="layout-sidebar" (click)="appMain.onMenuClick($event)">
  <a [routerLink]="['/']" class="logo">
    <img src="/assets/layout/images/logo1.svg" alt="rasm" width="173px"  height="56px"/>
  </a>
  <div class="layout-menu-container">
    <ul class="layout-menu">
      <ng-container *ngFor="let item of model; let i = index">
        <li
          app-menuitem
          *ngIf="!item.separator"
          [appMain]="appMain"
          [item]="item"
          [index]="i"
          [root]="true"
        ></li>
        <li *ngIf="!(!item.separator || i === 0)" class="menu-separator"></li>
      </ng-container>
    </ul>
  </div>
</div>
